<template>
    <page-table />
  </template>
  <script>
  import PageTable from './components/table'
  export default {
    name: 'order-budget',
    components: {
      PageTable,
    },
  }
  </script>